<div style="margin-top: 2%;border: 2px solid #446f8b;margin-bottom: 1%;">
    <div style="margin: 2%;">
        <div class="master-de">
            <dynamic-form #docSetForm [repeatCount]=4></dynamic-form>
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="requiredField.workflow_Status">
                    <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="displayText"  ValueField="dedId" WaterMarkText="Select Stage" [dataSource]='stageList' [defaultValue]='' setId="workflowId" (valueChange)='selectedStage($event)' [IsCascading]='true'>
                    </EIPAutoComplete>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="requiredField.doc_dci_type">
                    <EIPMultiSelectAutoComplete [dataSource]="Doc_type" setId="Doc_typeid" TextField="viewValue" ValueField="value" WaterMarkText="Schedule Type" ShowTextValueField='N' isEmitOnSelect="Y" (valueChange)="selectedScheduleType($event)">
                    </EIPMultiSelectAutoComplete>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="requiredField.fromtodate">
                    <EIPDateRangePicker WaterMark="Select From / To Date" setId="eipARDatePickerPeriod" [valueStart]="from_Date" [valueEnd]="to_Date" (selectedStartDate)='getFromDateValue($event)' (selectedEndDate)='getToDateValue($event)'>
                    </EIPDateRangePicker>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="requiredField.transmittal_no">
                    <mat-form-field>
                        <mat-label>Transmittal No.</mat-label>
                        <input matInput [(ngModel)]="transmittal_no"  >
                    </mat-form-field>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="requiredField.document_Set">
                    <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="document_Set_Name"  ValueField="doc_Set_Id" WaterMarkText="Document Set" [dataSource]='docSetList' [defaultValue]='' setId="ddlDocSet{{docIndex}}" (valueChange)='SelectedDocSet($event)' [IsCascading]='true'>
                    </EIPAutoComplete>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="requiredField.doc_no">
                    <mat-form-field>
                        <mat-label>Document No.</mat-label>
                        <input matInput [(ngModel)]="doc_no"  >
                    </mat-form-field>
                </div>
            </div>
            <div>
                <button style="float: right;margin-top: 0px;" [ngClass]="getClass()" class="btn btn-primary" (click)="valueChanged()"><i class="fa fa-search" title="Search" aria-hidden="true"></i>&nbsp;&nbsp;Search</button>
            </div>
        </div>
    </div>
</div>